import React from "react";
import { Route, Redirect } from "react-router-dom";
import HomePage from "../../features/home/HomePage";

const HomeRoute = ({ component: Component, location, ...rest }) => {
  const userLogged = localStorage.getItem("token");
  return (
    <Route
      exact
      path="/"
      render={() => (
        <>
          {userLogged ? (
            <Redirect to="inicio" {...rest} />
          ) : (
            <Route component={HomePage} />
          )}
        </>
      )}
    />
  );
};

export default HomeRoute;
